import type { Euler } from 'three';

import { useKeyPoseEditingCameraGate } from '../hooks/useKeyPoseEditingCameraGate';
import { useKeyPoseEditingDeselect } from '../hooks/useKeyPoseEditingDeselect';
import KeyPoseFkHandles from './KeyPoseFkHandles';
import KeyPoseIkHandles from './KeyPoseIkHandles';

interface KeyPoseEditingProps {
  sceneRotation?: Euler;
}

export default function KeyPoseEditing({ sceneRotation }: KeyPoseEditingProps) {
  const { onHandleDragStart } = useKeyPoseEditingDeselect();
  useKeyPoseEditingCameraGate();

  return (
    <>
      <KeyPoseIkHandles
        sceneRotation={sceneRotation}
        onHandleDragStart={onHandleDragStart}
      />
      <KeyPoseFkHandles
        sceneRotation={sceneRotation}
        onHandleDragStart={onHandleDragStart}
      />
    </>
  );
}
